/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

;// ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

;// ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

;// ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

;// ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

;// ./src/js/bundles/sections/faq-sections.js

var initFaqSectionScript = function initFaqSectionScript() {
  var faqSection = document.querySelector('.faq-section');
  var faqTitles = faqSection === null || faqSection === void 0 ? void 0 : faqSection.querySelectorAll('.faq-titles button');
  var faqItems = faqSection === null || faqSection === void 0 ? void 0 : faqSection.querySelectorAll('.faq-item');
  var faqSelect = faqSection === null || faqSection === void 0 ? void 0 : faqSection.querySelector('.faq-select');
  var selectedFaqTitle = faqSection === null || faqSection === void 0 ? void 0 : faqSection.querySelector('.faq__selected-title');
  var faqButtons = faqSection === null || faqSection === void 0 ? void 0 : faqSection.querySelectorAll('.faq-item button');
  var activeAccordions = [];
  function toggleFaq(key) {
    // Clear active accordions before adding new ones
    activeAccordions = [];
    faqItems.forEach(function (item) {
      var isActive = item.dataset.key === key;
      item.classList.toggle('hidden', !isActive);
      if (isActive) {
        activeAccordions.push(item);
      }
    });

    // Ensure only the first accordion of the active FAQ items is open
    activeAccordions.forEach(function (item, id) {
      var isFirstAccordion = id === 0;
      toggleAccordion(item, isFirstAccordion);
    });
    handleUpdateFaqTitle(key);
  }
  function handleUpdateFaqTitle(titleId) {
    var matchingTitle = _toConsumableArray(faqTitles).find(function (title) {
      return title.dataset.key === titleId;
    });
    if (matchingTitle) {
      selectedFaqTitle.textContent = matchingTitle.textContent;
    }
    faqTitles.forEach(function (title) {
      title.classList.remove('is-active');
    });
    if (matchingTitle) {
      matchingTitle.classList.add('is-active');
    }
  }
  function toggleAccordion(accordion, condition) {
    accordion.classList.toggle('accordion-active', condition);
  }
  faqTitles.forEach(function (title) {
    title.addEventListener('click', function () {
      toggleFaq(title.dataset.key);
    });
  });
  if (faqSelect) {
    faqSelect.addEventListener('change', function () {
      toggleFaq(faqSelect.value);
    });
  }
  if (faqTitles.length > 0) {
    var firstKey = faqTitles[0].dataset.key;
    toggleFaq(firstKey);
  }

  // Apply the accordion logic to each button
  faqButtons.forEach(function (button) {
    var faqItem = button.closest('.faq-item');
    button.addEventListener('click', function () {
      toggleAccordion(faqItem);
    });
  });
};
;// ./src/js/bundles/templates/page.faq.js

initFaqSectionScript();
/******/ })()
;